import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const popover: ThemeAPI['popover'] = {
  info: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.infoBackgroundSolid,
      borderColor: theme.colors.infoBorder,
    },
  },
  warning: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.warningBackgroundSolid,
      borderColor: theme.colors.warningBorder,
    },
  },
  error: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.criticalBackgroundSolid,
      borderColor: theme.colors.criticalBorder,
    },
  },
}
